import React from 'react';
import { Container, Typography, Box, Grid, Stack, Link, Divider } from '@mui/material';
import CopyrightIcon from '@mui/icons-material/Copyright';
import { withPublic } from '../src/hook/route';
import getPricePlans from '../lib/pricing/_getPricePlans';
import Authentication from '../src/components/Authentication';
import stock_sum from '../src/static/images/page/home/stock_sum.png';
import sec_filing from '../src/static/images/page/home/sec_filing.png';
import aapl_chart from '../src/static/images/page/home/apple_chart.png';
import { colors, radii, shadows } from '../src/utils/designTokens';

const Auth = ({ pricePlans }) => (
  <Grid container sx={{ minHeight: '100vh' }}>
    <Grid
      size={{ xs: 12, md: 5 }}
      sx={{
        display: { xs: 'none', sm: 'none', md: 'flex' },
        flexDirection: 'column',
        justifyContent: 'space-between',
        background: `linear-gradient(165deg, ${colors.primary.dark} 0%, ${colors.primary.main} 40%, ${colors.primary.light} 100%)`,
        position: 'relative',
        overflow: 'hidden',
        zIndex: 1,
      }}
    >
      <Box sx={{
        position: 'absolute', top: '-20%', right: '-30%',
        width: '80%', height: '80%', borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255,255,255,0.06) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />

      <Box sx={{
        flex: 1, position: 'relative', m: 3, overflow: 'hidden',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <Box sx={{ position: 'relative', width: '100%', height: '80%' }}>
          <img src={stock_sum.src} alt="Stock summary" style={{
            filter: 'drop-shadow(0 12px 32px rgba(0,0,0,0.4))',
            transition: 'transform 0.5s cubic-bezier(0.4,0,0.2,1)',
            display: 'block', height: 'auto', borderRadius: 12,
            width: 420, position: 'absolute', top: '5%', left: '-15%',
          }} />
          <img src={sec_filing.src} alt="SEC filing" style={{
            filter: 'drop-shadow(0 12px 32px rgba(0,0,0,0.4))',
            transition: 'transform 0.5s cubic-bezier(0.4,0,0.2,1)',
            display: 'block', height: 'auto', borderRadius: 12,
            width: 320, position: 'absolute', top: '42%', left: '5%',
          }} />
          <img src={aapl_chart.src} alt="Apple chart" style={{
            filter: 'drop-shadow(0 12px 32px rgba(0,0,0,0.4))',
            transition: 'transform 0.5s cubic-bezier(0.4,0,0.2,1)',
            display: 'block', height: 'auto', borderRadius: 12,
            width: 320, position: 'absolute', top: '28%', left: '30%',
          }} />
        </Box>
      </Box>

      <Box sx={{ px: 4, pb: 4 }}>
        <Typography sx={{
          color: '#fff', fontWeight: 600, fontSize: '1.375rem',
          lineHeight: 1.3, letterSpacing: '-0.01em', mb: 1.5,
        }}>
          All the financial data and tools you need, in one place.
        </Typography>
        <Typography sx={{
          color: 'rgba(255,255,255,0.65)', fontSize: '0.938rem',
          lineHeight: 1.5, fontStyle: 'italic',
        }}>
          &ldquo;...eliminates the gap between hedge funds and retail investors.&rdquo;
        </Typography>
      </Box>
    </Grid>

    <Grid
      id="plans"
      size={{ xs: 12, md: 7 }}
      sx={{
        display: 'flex', flexDirection: 'column',
        bgcolor: colors.neutral[25],
      }}
    >
      <Box sx={{
        flex: 1, display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        px: { xs: 2, sm: 4 },
        overflow: 'auto',
      }}>
        <Authentication pricePlans={pricePlans} maxWidth={6.5} comp="auth-landing" />
      </Box>

      <Box sx={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        pb: 3, pt: 2, gap: 1.5,
      }}>
        <Stack
          direction="row"
          divider={<Divider orientation="vertical" flexItem sx={{ borderColor: colors.neutral[300] }} />}
          spacing={2}
          sx={{
            display: { xs: 'none', sm: 'inline-flex' },
            '& a': {
              color: colors.neutral[500], textDecoration: 'none', fontSize: '.84rem',
              transition: 'color 150ms ease',
              '&:hover': { color: colors.neutral[800] },
            },
          }}
        >
          <Link href="/terms">Terms</Link>
          <Link href="/privacy">Privacy</Link>
        </Stack>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <CopyrightIcon sx={{ fontSize: '.75rem', mr: 0.5, color: colors.neutral[400] }} />
          <Typography variant="caption" sx={{ color: colors.neutral[400], fontSize: '.75rem' }}>
            Knowtilus Technologies Pvt. Ltd. All Rights Reserved
          </Typography>
        </Box>
      </Box>
    </Grid>
  </Grid>
);

export const getStaticProps = async () => {
  const { plans } = (await getPricePlans()) || {};
  return { props: { pricePlans: plans || {} } };
};

export default withPublic(Auth);
